import React from "react"
import { Link } from "gatsby"

import Layout from "../components/layout"
import Navigation from "../components/Navigation"
import { RavioliImage } from "../components/image"
import TortellinisImage from "../components/tortellini"
import SEO from "../components/seo"

const IndexPage = () => (
  <Layout>
    <SEO title="Home" />
    <h2 className="Home__title">Lavoretto</h2>

    <div className="container-sm">
      <div className="image"><RavioliImage /></div>
      <div className="image"><TortellinisImage /></div>
    </div>



    {/* <SEO title="Home" />
    <h1>Hi people</h1>
    <p>Welcome to your new Gatsby site.</p>
    <p>Now go build something great.</p>
    <div style={{ maxWidth: `300px`, marginBottom: `1.45rem` }}>
      <Image />
    </div>
    <Link to="/page-2/">Go to page 2</Link> */}
  </Layout>
)

export default IndexPage
